import axios from 'axios';
import {
    getAuthHeader
} from "@/services/user.service.js";


export {
    GetCriterion,
    SaveCriterion,
    GetCriterionPreview
};

function GetCriterion(contractNumber, versionNumber, editionId, criterionTypeId, onSuccess, onError){
    
    var headers = getAuthHeader();
    
    axios
        .get(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/klauseltypes/${criterionTypeId}`, headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        }
    );
}

function SaveCriterion(contractNumber, versionNumber, editionId, criterionTypeId, criterionObject, onSuccess, onError){
    
    var headers = getAuthHeader();
    
    axios
        .put(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/klauseltypes/${criterionTypeId}`, criterionObject, headers)
        .then(() => {
            onSuccess();
        })
        .catch(error => {
            onError(error);
        }
    );
}

function GetCriterionPreview(contractNumber, versionNumber, editionId, criterionTypeId, preciewRequestObject, onSuccess, onError){
        var headers = getAuthHeader();
    
    axios
        .put(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/klauseltypes/${criterionTypeId}/preview`, 
            preciewRequestObject, 
            headers
        )
        .then((response) => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        }
    );
}
